export enum EMiniGames {
  PUZZLE = "PUZZLE",
  HACK_TERMINAL = "HACK_TERMINAL",
}
